















import { Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';

import { Modules, Action } from '../../store/store';
import { namespace } from 'vuex-class';

import type { SubBrand, Theme } from '../../store/modules/themes';
import { Vehicle } from '../../store/modules/charging-data.interface';

const themeModule = namespace(Modules.themes);
const dataModule = namespace(Modules.chargingData);
const configModule = namespace(Modules.config);

@Component({
  name: 'eqweb-vehicle-selection',
})
export default class VehicleSelection extends Vue {
  @dataModule.State('selectedVehicle')
  private readonly selectedVehicle!: Vehicle;

  @themeModule.Getter('propsTheme')
  private readonly theme!: Theme;

  @themeModule.Getter('subBrand')
  private readonly subBrand!: SubBrand;

  @dataModule.Getter('vehicles')
  private readonly vehicles!: Vehicle[];

  @configModule.Getter('asSidebar')
  private readonly asSidebar!: boolean;

  @dataModule.Action('setSelectedVehicle')
  private setSelectedVehicle!: Action<Vehicle>;

  updateSelectedVehicle(event: Event & { target: HTMLInputElement }): void {
    const vehicle = this.vehicles.find((vehicle) => {
      return vehicle.typeId === event.target.value;
    });
    if (vehicle) {
      this.setSelectedVehicle(vehicle);
    }
  }
}
